export class GameOverResponse {
    static Message = 'GameOverResponse';

    public winnerId: string;
    public winnerName: string;

    constructor(winnerId: string, winnerName: string) {
        this.winnerId = winnerId;
        this.winnerName = winnerName;
    }
}
